import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {catchError, finalize, tap} from 'rxjs/operators';
import {BehaviorSubject, throwError} from 'rxjs';

import {RoutingService} from '../routing.service';
import {StorageService} from '../storage.service';
import {AppSettingsService, SubdomainEnum} from '../app-settings.service';
import {InvestorContactReqRes} from '../../dashboard/contacts/models/investorContactReqRes.model';
import {ImpersonateAsUserDetails} from '../../models/ImpersonateAsUserDetails.model';
import {UserService} from './user.service';
import {LoggerService} from '../../shared/errors/logger.service';

@Injectable({
  providedIn: 'root'
})
export class ImpersonationService {
  private _isLoadingImpersonation$ = new BehaviorSubject<boolean>(false);
  isLoadingImpersonation$ = this._isLoadingImpersonation$.asObservable();

  constructor(private routingService: RoutingService,
              private router: Router,
              private storageService: StorageService,
              private appSettings: AppSettingsService,
              private userService: UserService,
              private logger: LoggerService) {
  }

  public get isViewingAsInvestor(): boolean {
    return this.appSettings.subDomain === SubdomainEnum.GP && window.location.pathname.startsWith('/lp') &&
           !!this.impersonateAsUsername;
  }

  public get impersonateAsUsername(): string {
    return this.impersonateAsDetails?.username;
  }

  public get impersonateAsDetails(): ImpersonateAsUserDetails {
    return this.storageService.getImpersonateAsData();
  }
  public viewAsInvestor(contact: InvestorContactReqRes) {
    const impersonationData = new ImpersonateAsUserDetails();
    impersonationData.username = contact.email;
    impersonationData.firstName = contact.firstName;
    impersonationData.lastName = contact.lastName;
    this._isLoadingImpersonation$.next(true);
    return this.userService.addLpForImpersonation(impersonationData.username).pipe(
      tap(_ => {
        this.storageService.setImpersonateAsData(impersonationData);
        const url = this.router.serializeUrl(this.router.createUrlTree([this.routingService.lpHoldingsPage]));
        window.open(url, '_blank');
      }),
      finalize(() => {
        this._isLoadingImpersonation$.next(false);
      }),
      catchError(error => {
        this.logger.error(`viewAsLp => error viewing LP portal as ${impersonationData.username}`, error);
        return throwError(error);
      })
    );
  }
}
